import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Options } from 'ng5-slider';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from '../api.service';
import { BiciVerMasAsistenciasComponent } from '../blocks/bici-ver-mas-asistencias/bici-ver-mas-asistencias.component';
import { BiciVerNumeroSerieComponent } from '../blocks/bici-ver-numero-serie/bici-ver-numero-serie.component';
import { ConfirmacionDatosComponent } from '../blocks/confirmacion-datos/confirmacion-datos.component';
import { ProteccionDatosComponent } from '../blocks/proteccion-datos/proteccion-datos.component';
import { TecnologiaTcComponent } from '../blocks/tecnologia-tc/tecnologia-tc.component';
import { formatNumber } from '@angular/common';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';

declare var fbq;
declare var gtag;

@Component({
  selector: 'app-cotizador-bici-opc2',
  templateUrl: './cotizador-bici-opc2.component.html',
  styles: []
})
export class CotizadorBiciOpc2Component implements OnInit {
  data: any = {};
  errors: any = [];
  path: any = "";
  waTxt: any = "";

  isLoading: boolean = false;
  manualSelect: boolean = false;
  manualSelectStep: number = 1;
  cotizador: any = null;
  coberturas: any = null;
  provincias: any = null;
  ocupaciones: any = null;
  nacionalidades: any = null;
  planes: any = null;
  planSeleccionado: any = null;
  ccHorario: any = "";
  isContactSelected: boolean = false;
  showNroSerie: boolean = false;

  sa: number = 0;
  min_sa: number = 0;
  max_sa: number = 0;
  saOptions: any = null;

  options: Options = {
    step: 100,
    showSelectionBar: true,
    translate: (value: number): string => {
      return '$' + value;
    }
  };

  constructor(
    private api: ApiService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService
  ) {
    this.path = this.route.routeConfig.path;

    this.api.getCotizador("BI").subscribe(x => {
      window.scrollTo(0, 0);
      this.cotizador = x.data;
      this.cotizador.codigo = "BI2";
      this.getTopes();
    });

    let tmpCanal = document.location.href.split("?");

    this.data.origen = localStorage.getItem('bia_origen');
    if (tmpCanal[1]) {
      this.data.canal = tmpCanal[1];
      let cparts = tmpCanal[1].split('=');
      if (cparts[1]){
        this.data.origen = cparts[1];
        localStorage.setItem('bia_origen', this.data.origen);
      }
    }

    this.api.getHorariosCC().subscribe(x => {
      this.ccHorario = x.data.mensaje;
    });

  }

  captcha(e: any) {
    this.data.captcha = e;
  }

  selectPlan(evt: any) { 
    window.scrollTo(0, 0);
    //console.log(evt);
    this.planSeleccionado = evt.plan;
    this.data.plan = evt.plan.nombre;
    this.data.planId = evt.plan.productoId;
    this.data.cuota_mensual = evt.plan.cuota_mensual;

    this.trackEvent("Seleccionar", "Bici Banco Home Planes", evt.plan.displayName);

    localStorage.removeItem("nroserie");
    if (this.planSeleccionado.productoId >= 5) {
      localStorage.setItem("nroserie", "1");
    }

    this.updateLead(3);

  }

  getTopes() {
    this.api.getCoberturasTopes(this.cotizador.coberturaReferencia).subscribe(x => {

     
      this.min_sa = x.data.min;
      this.max_sa = x.data.max;
      this.saOptions = x.data.all;

      if (this.path == 'bicicletas-planes') {
        this.api.getProductosRecomendadosById(this.cotizador.coberturaReferencia, [2,4,5]).subscribe(x => {
          this.planes = x.data;
          this.data.step = 1;
          this.data.tipo_contacto = "";
        });

      }

      if (this.path == 'bicicletas-banco-gracias') {

        if (localStorage.getItem("waTxt")) {
          this.waTxt = localStorage.getItem("waTxt");
        }
        
        if (localStorage.getItem("tipoContacto")) {
          if (localStorage.getItem("nroserie")) {
            this.showNroSerie = true;
          }
          this.data.tipo_contacto = localStorage.getItem("tipoContacto");

          switch (this.data.tipo_contacto) {
            case "W":
              this.trackEvent("Seleccionar", "Bici Banco Paso 3 TUP", "WhatsApp");
              fbq('trackCustom', 'Seguro Bici - Formulario Completo');
              break;
            case "M":
              this.trackEvent("Seleccionar", "Bici Banco Paso 3 TUP", "Email");
              fbq('trackCustom', 'Seguro Bici - Formulario Completo');
              break;
            case "T":
              this.trackEvent("Seleccionar", "Bici Banco Paso 3 TUP", "Telefono");
              fbq('trackCustom', 'Seguro Bici - Formulario Completo');
              break;
          }

          this.data.step = 5;
          localStorage.removeItem("tipoContacto");
        } else {
          document.location.href = "bicicletas-planes";
        }

      }

      if (this.path == 'bicicletas-planes-nps') {
        this.data.step = 6;
      }

      if (this.path == 'bicicletas-planes-unsuscribe') {
        this.data.step = 7;
      }

    });
  }

  ngOnInit() {
  }

  selectManual() {

    this.trackEvent("Seleccionar", "Bici Banco Home Personalizar", "Personalizar plan");

    this.manualSelect = true;
    window.scrollTo(0, 0);
  }

  goToStep(step: number, el: string = "") {
    this.data.step = step;

    if (el == "") {
      window.scrollTo(0, 0);
    } else {
      setTimeout(() => {
        var elmnt = document.getElementById(el);
        elmnt.scrollIntoView();
      }, 500);
    }
  }

  goTo(el: string) {

    if (el == "") {
      window.scrollTo(0, 0);
    } else {

      if(el == 'planes'){
        this.trackEvent("Seleccionar", "Bici Banco Home Header", "Seleccionar Plan");
      }

      setTimeout(() => {

        $('html, body').animate({
          scrollTop: $("#" + el).offset().top
        }, 1000);

        /*
        var elmnt = document.getElementById(el);
        elmnt.scrollIntoView({ behavior: 'smooth', block: 'start' });
        */
      }, 200);
    }
  }
  
  cotizar() {

    this.spinner.show();
    this.data.cotizador = this.cotizador.codigo;

    this.api.updateLead(this.data).subscribe(ret => {

      if (ret.status == "ok") {
        this.errors = [];
        this.data = ret.data;

        this.api.getProductosRecomendadosBySa(this.cotizador.coberturaReferencia, this.data.sa).subscribe(x => {

          this.planSeleccionado = {
            coberturas: x.data.recomendado.coberturas,
            cuota_mensual: x.data.recomendado.cuota_mensual,
            displayName: x.data.recomendado.nombre,
            nombre: x.data.recomendado.nombre,
            productoId: x.data.recomendado.productoId,
            valor: x.data.recomendado.valor
          }

          this.data.plan = this.planSeleccionado.nombre;
          this.data.cuota_mensual = this.planSeleccionado.cuota_mensual;
          this.data.planId = this.planSeleccionado.productoId;

          if (this.data.step == 1) {
            this.trackEvent("Seleccionar", "Bici Banco Personalizar SA", "Cotizar");
            this.goToStep(2);
          }

          this.spinner.hide();
        });

      }

      if (ret.status == "error") {
        this.errors = ret.errors;
        this.goToStep(this.data.step, "secCotizador");
        this.spinner.hide();
      }

    }, err => {
      alert("Se ha producido un error");
    });


  }

  selectPlanPersonalizado() {
    localStorage.removeItem("nroserie");
    if (this.planSeleccionado.productoId >= 5) {
      localStorage.setItem("nroserie", "1");
    }

    this.trackEvent("Seleccionar", "Bici Banco Personalizar SA", "Seleccionar");
    this.goToStep(3);
  }

  doSelectTipoContactoRadio(tipoContacto: any) {
    this.data.tipo_contacto = tipoContacto;
    this.isContactSelected = true;
  }

  changePlan() {
    this.trackEvent("Seleccionar", "Bici Planes Datos", "Modificar Plan");
    this.goToStep(1);
  }

  chooseOtherPlan() {
    this.trackEvent("Seleccionar", "Bici Planes Datos", "Elegir otro Plan");
    this.goToStep(1);
  }
  
  finalizar() {
    this.updateLead(5);
  }

  updateLead(stepTo: number) {
    window.scrollTo(0, 0);

    this.spinner.show();

    this.data.cotizador = this.cotizador.codigo;

    this.api.updateLead(this.data).subscribe(ret => {

      if (ret.status == "ok") {

        if (stepTo == 1) {
          this.errors = [];
          this.data = ret.data;
          this.data.step = stepTo;
          this.spinner.hide();
        }

        if (stepTo == 2) {
          this.errors = [];
          this.data = ret.data;
          this.data.step = stepTo;
          this.spinner.hide();
        }

        if (stepTo == 3) {
          this.errors = [];
          this.data = ret.data;
          this.data.step = stepTo;
          this.spinner.hide();
        }

        console.log(ret);

        if (stepTo == 4) {
          this.trackEvent("Seleccionar", "Bici Bando Paso 1 Datos", "Guardar");
          this.trackEvent("Seleccionar", "Bici Banco Lead", "Datos Completos", "Lead");
          this.errors = [];
          this.data = ret.data;
          this.data.step = stepTo;
          this.data.finde = ret.finde;
          console.log(ret);
          this.spinner.hide();
        }

        if (stepTo == 5) {
          if (this.data.tipo_contacto == "W") {
            ///TODO
            let txt = '';
            //if (this.data.finde) txt = '¡Hola! ¡Gracias por cotizar tu seguro con Supervielle Seguros! Nuestro horario de atención es de lunes a viernes de 9hs a 21hs. ¡Dejanos tu consulta y a la brevedad te respondemos! ¡Saludos!';
            //else txt = '¡Hola! Coticé mi seguro de Bicicletas Banco, el precio mensual es $' + formatNumber(this.data.cuota_mensual, 'es-AR', '1.0-0') + '. Mi ID de cotización es ' + this.data.id + '.';
            txt = '¡Hola! Coticé mi seguro de Bicicleta, el precio mensual es $' + formatNumber(this.data.cuota_mensual, 'es-AR', '1.0-0') + '. Mi ID de cotización es ' + this.data.id + '.';
            let num = '+541138077581'; 
            let url = 'https://wa.me/' + num + '?text=' + txt;
            let a = document.createElement("a");

            localStorage.setItem("waTxt", txt);

            document.body.appendChild(a);
            a.href = url;
            a.target = "_blank";
            a.click();
            document.body.removeChild(a);

          }

          let params = {
            lead: this.data,
            cotizacion: this.cotizador,
            tipo: this.data.tipo_contacto,
            plan: this.planSeleccionado
          }

          this.api.sendCotizacion(params).subscribe(ret => {
            localStorage.setItem("tipoContacto", this.data.tipo_contacto);
            this.spinner.hide();
            document.location.href = "bicicletas-banco-gracias";
          });



        }


      }

      if (ret.status == "error") {
        this.errors = ret.errors;
        this.spinner.hide();
      }

    }, err => {
      alert("Se ha producido un error");
    });



  }

  showProteccionDatos() {
    this.modalService.open(ProteccionDatosComponent, { size: <any>'tecno-proteccion-datos bi' });
  }

  showTC() {
    this.modalService.open(TecnologiaTcComponent, { size: <any>'tecno-proteccion-datos bi' });
  }

  verMasAsistencias() {
    this.trackEvent('Seleccionar', 'Bici Banco Paso 2 Medio', 'Ver Asistencias');
    this.modalService.open(BiciVerMasAsistenciasComponent, { size: <any>'ver-mas-asistencias' });
  }

  verNroSerie() {
    this.modalService.open(BiciVerNumeroSerieComponent, { size: <any>'ver-mas-asistencias' });
  }

  trackEvent(gAction = null, gCategory = "", gLabel = "", FbEvent = null) {

    console.log("Categoria: " + gCategory + " | Accion: " + gAction + " | Etiqueta: " + gLabel);

    if (gAction) {
      gtag('event', gAction, {
        'event_category': gCategory,
        'event_label': gLabel
      });
    }

    if (FbEvent) {
      console.log("FBPixel: " + FbEvent);
      fbq('track', FbEvent);
    }
  }

}

